import React, { useState } from "react";

const NutritionLogsDays = ({ timelineLogs, detailedLogs }) => {
  const [activeTab, setActiveTab] = useState("timeline");

  return (
    <section className="tme-nutrition-analysis__logs">
      <div className="tme-nutrition-analysis__logs-header">
        <h4>Nutrition Logs (Last 14 Days)</h4>
        <div className="tme-nutrition-analysis__logs-tabs">
          <button
            onClick={() => setActiveTab("timeline")}
            className={`tme-nutrition-analysis__tab${
              activeTab === "timeline"
                ? " tme-nutrition-analysis__tab--active"
                : ""
            }`}
          >
            Timeline View
          </button>
          <button
            onClick={() => setActiveTab("detailed")}
            className={`tme-nutrition-analysis__tab${
              activeTab === "detailed"
                ? " tme-nutrition-analysis__tab--active"
                : ""
            }`}
          >
            Detailed View
          </button>
        </div>
      </div>

      {activeTab === "timeline" ? (
        timelineLogs.map((log, idx) => {
          // Calculate logged meals count
          const loggedMealsCount = log.meals.filter(meal => meal.kcal > 0).length;
          const totalMealsCount = log.meals.length;
          
          return (
            <div key={idx} className={`tme-nutrition-analysis__log-card`}>
              <div className="tme-nutrition-analysis__log-left">
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                <div>
                <div className="tme-nutrition-analysis__log-top">
                  <div className="tme-nutrition-analysis__log-header">
                    <div className="tme-nutrition-analysis__log-date">{log.date}</div>
                    <div className="tme-nutrition-analysis__log-pills">
                      <span className="tme-nutrition-analysis__log-pill tme-nutrition-analysis__log-pill--black">
                        {loggedMealsCount}/{totalMealsCount} meals logged
                      </span>
                      <span className="tme-nutrition-analysis__log-pill tme-nutrition-analysis__log-pill--blue">
                        ✓ Reviewed
                      </span>
                    </div>
                  </div>
                </div>
                </div>
               <div>
               <div className="tme-nutrition-analysis__log-kcal">{log.totalKcal}</div>
               <div className="tme-nutrition-analysis__log-kcal-unit">kcal</div>
               </div>
               </div>
                <div className="tme-nutrition-analysis__meals-row">
                  {log.meals.map((m, i) => (
                    <div key={i} className={`tme-nutrition-analysis__meal${m.kcal > 0 ? "" : " tme-nutrition-analysis__meal--pending"}`}>
                      <div className="tme-nutrition-analysis__meal-top">
                        <span className={`tme-nutrition-analysis__status-dot${m.kcal > 0 ? " tme-nutrition-analysis__status-dot--ok" : " tme-nutrition-analysis__status-dot--pending"}`} aria-hidden />
                        <div className="tme-nutrition-analysis__meal-name">{m.name}</div>
                      </div>
                      <div className="tme-nutrition-analysis__meal-kcal">{m.kcal ? `${m.kcal} kcal` : "--"}</div>
                    </div>
                  ))}
                </div>
                {/* <div className="tme-nutrition-analysis__log-extra">
                  <div className="tme-nutrition-analysis__water-intake">
                    💧 4L water
                  </div>
                  <div className="tme-nutrition-analysis__comment">
                    💬 "Keep it up"
                  </div>
                </div> */}
              </div>
            </div>
          );
        })
      ) : (
        detailedLogs.map((log, idx) => {
          // Define color classes for different meal types
          const getMealCardClass = (mealName, index) => {
            const name = mealName.toLowerCase();
            if (name.includes('breakfast')) return 'tme-nutrition-analysis__detail-card--yellow';
            if (name.includes('lunch')) return 'tme-nutrition-analysis__detail-card--peach';
            if (name.includes('dinner')) return 'tme-nutrition-analysis__detail-card--blue';
            if (name.includes('snacks')) return 'tme-nutrition-analysis__detail-card--green';
            // Default fallback based on index
            const colors = ['yellow', 'peach', 'blue', 'green'];
            return `tme-nutrition-analysis__detail-card--${colors[index % colors.length]}`;
          };

          return (
            <div key={idx} className="tme-nutrition-analysis__detail">
              <div className="tme-nutrition-analysis__detail-head">
                <div className="tme-nutrition-analysis__detail-date">
                  {log.date}
                </div>
                <div className="tme-nutrition-analysis__detail-pill">
                  {log.totalKcal} kcal
                </div>
              </div>
              <div className="tme-nutrition-analysis__detail-grid">
                {log.meals.map((m, i) => (
                  <div
                    key={i}
                    className={`tme-nutrition-analysis__detail-card ${getMealCardClass(m.name, i)}`}
                  >
                    <div className="tme-nutrition-analysis__detail-title">
                      {m.name} - {m.kcal} kcal
                    </div>
                    <ul className="tme-nutrition-analysis__detail-list">
                      {m.items.map((it, j) => (
                        <li key={j}>{it}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              
              {/* Water Intake Section */}
              {/* <div className="tme-nutrition-analysis__detail-water">
                <div className="tme-nutrition-analysis__water-content">
                  <span className="tme-nutrition-analysis__water-icon">💧</span>
                  <span className="tme-nutrition-analysis__water-text">Water Intake: 2L</span>
                </div>
                <div className="tme-nutrition-analysis__water-pill">
                  ✓ Trainer Reviewed
                </div>
              </div> */}
              
              {/* Trainer Feedback Section */}
              {/* <div className="tme-nutrition-analysis__detail-feedback">
                <div className="tme-nutrition-analysis__feedback-content">
                  <span className="tme-nutrition-analysis__feedback-icon">💬</span>
                  <span className="tme-nutrition-analysis__feedback-title">Trainer Feedback</span>
                </div>
                <div className="tme-nutrition-analysis__feedback-text">
                  Need more protein
                </div>
              </div> */}
            </div>
          );
        })
      )}
    </section>
  );
};

export default NutritionLogsDays;
